export default __webpack_public_path__ + "static/cafe_36009-29f13fdbe7f76bbcc4e2b93b4cffea6a.png";